<div class="edit-seats-object">
    <div class="d-flex align-items-center mb-3 title-section" (click)="cancelEdit(true)">
        <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
        <p class="m-0">Sección</p>
    </div>

    <!-- Identidad -->
    <div class="panel-group">
        <p class="panel-group__title">Identidad</p>
        <div class="field" *ngIf="levels?.length > 0 && !isZone && !isLine">
            <label class="field__label">Nivel</label>
            <select class="field-input" [(ngModel)]="selectedLevel" (change)="editLevel()">
                <option [ngValue]="null">Sin nivel</option>
                <option *ngFor="let level of levels" [ngValue]="level">{{level.name}}</option>
            </select>
        </div>
        <div class="field" *ngIf="!isZone && !isLine">
            <label class="field__label">Identificador de área</label>
            <input class="field-input field-input--sm" type="text" placeholder="ID" [(ngModel)]="sectionNumber" (change)="editSection()" required>
        </div>
        <div class="field">
            <label class="field__label">Nombre</label>
            <input class="field-input" type="text" placeholder="Nombre" [(ngModel)]="sectionName" (change)="editNameSection()" required>
        </div>
    </div>

    <!-- Zona de navegación -->
    <div class="panel-group" *ngIf="isZone">
        <p class="panel-group__title">Zona de navegación</p>
        <p class="field-hint">
            Esta zona será clicable en el plano general: al pulsarla, el mapa hace zoom a sus niveles. El «Nombre» se usa como etiqueta.
        </p>
        <div class="field">
            <label class="field__label">Tamaño de etiqueta</label>
            <input class="field-input field-input--sm" type="number" min="8" max="200" step="2" [(ngModel)]="labelFontSize" (change)="editLabelFontSize()">
        </div>
        <div class="field-range">
            <div class="field-range__head">
                <label class="field__label">Rotar etiqueta</label>
                <span class="field-range__value">
                    <input type="number" min="-180" max="180" step="1" [(ngModel)]="labelAngle" (input)="editLabelAngle()">
                    <span class="field-range__unit">°</span>
                </span>
            </div>
            <input type="range" min="-180" max="180" step="1" [(ngModel)]="labelAngle" (input)="editLabelAngle()" class="slider-rotation">
        </div>
        <div class="field">
            <label class="field__label">Mostrar etiqueta</label>
            <mat-checkbox [ngModel]="!hideLabel" [ngModelOptions]="{standalone: true}" class="checkbox" color="primary"
                (ngModelChange)="hideLabel = !$event; editHideLabel()">
            </mat-checkbox>
        </div>

        <div class="picker" *ngIf="availableLevels?.length > 0">
            <div class="picker__head">
                <p class="picker__title">Niveles de esta zona</p>
                <span class="picker__count">{{selectedCount}}/{{availableLevels.length}}</span>
            </div>
            <div class="picker__search">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;">
                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input type="text" [(ngModel)]="levelSearch" placeholder="Buscar nivel...">
            </div>
            <div class="picker__list">
                <div *ngFor="let lvl of filteredLevels" class="picker__item">
                    <mat-checkbox [(ngModel)]="selectedLevelsMap[+lvl.id]" (ngModelChange)="toggleLevel($event, lvl.id)" class="checkbox" color="primary"></mat-checkbox>
                    <p>{{lvl.name}}</p>
                </div>
                <p *ngIf="filteredLevels.length === 0" class="picker__empty">Sin resultados para «{{levelSearch}}».</p>
            </div>
            <div class="picker__actions">
                <span class="link" (click)="setLevelsSelected(true)">Seleccionar todos</span>
                <span class="sep">·</span>
                <span class="link" (click)="setLevelsSelected(false)">Ninguno</span>
            </div>
        </div>

        <div class="picker" *ngIf="availableShapes?.length > 0">
            <div class="picker__head">
                <p class="picker__title">Elementos de referencia</p>
                <span class="picker__count">{{selectedShapesCount}}/{{availableShapes.length}}</span>
            </div>
            <div class="picker__search">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;">
                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input type="text" [(ngModel)]="shapeSearch" placeholder="Buscar elemento...">
            </div>
            <div class="picker__list">
                <ng-container *ngFor="let group of groupedShapes; trackBy: trackByGroupLabel">
                    <div class="picker__group" (click)="toggleGroupCollapsed(group.label)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#aaa" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            [style.transform]="collapsedGroups[group.label] ? 'rotate(-90deg)' : 'rotate(0deg)'">
                            <polyline points="6 9 12 15 18 9"/>
                        </svg>
                        <span>{{group.label}}</span>
                    </div>
                    <ng-container *ngIf="!collapsedGroups[group.label]">
                        <div *ngFor="let shape of group.shapes; trackBy: trackByShapeId" class="picker__item">
                            <mat-checkbox [(ngModel)]="selectedShapesMap[shape.id]" (ngModelChange)="toggleShape($event, shape.id)" class="checkbox" color="primary"></mat-checkbox>
                            <p>{{shape.name}}</p>
                        </div>
                    </ng-container>
                </ng-container>
                <p *ngIf="filteredShapes.length === 0" class="picker__empty">Sin resultados para «{{shapeSearch}}».</p>
            </div>
            <div class="picker__actions">
                <span class="link" (click)="setShapesSelected(true)">Seleccionar todos</span>
                <span class="sep">·</span>
                <span class="link" (click)="setShapesSelected(false)">Ninguno</span>
            </div>
        </div>
    </div>

    <!-- Apariencia -->
    <div class="panel-group">
        <p class="panel-group__title">Apariencia</p>
        <div class="field" *ngIf="!isLine">
            <label class="field__label">Fondo</label>
            <mat-checkbox [(ngModel)]="hasBackground" class="checkbox" color="primary" (change)="editBackground()"></mat-checkbox>
        </div>
        <div class="field" *ngIf="hasBackground && !isLine">
            <label class="field__label">Color de relleno</label>
            <div class="field-color">
                <input class="field-input field-input--hex" type="text" placeholder="#Hex" [(ngModel)]="colorDefault" (change)="editColor()">
                <span class="field-color__swatch">
                    <input type="color" [(ngModel)]="colorDefault" (input)="editColor()">
                </span>
            </div>
        </div>
        <div class="field" *ngIf="!isLine">
            <label class="field__label">Borde</label>
            <mat-checkbox [(ngModel)]="hasBorder" class="checkbox" color="primary" (change)="editBorder()"></mat-checkbox>
        </div>
        <div class="field" *ngIf="hasBorder || isLine">
            <label class="field__label">{{ isLine ? 'Color' : 'Color del borde' }}</label>
            <div class="field-color">
                <input class="field-input field-input--hex" type="text" placeholder="#Hex" [(ngModel)]="colorBorde" (change)="editColor()">
                <span class="field-color__swatch">
                    <input type="color" [(ngModel)]="colorBorde" (input)="editColor()">
                </span>
            </div>
        </div>
        <div class="field" *ngIf="hasBorder && !isLine">
            <label class="field__label">Grosor del borde</label>
            <input class="field-input field-input--sm" type="number" min="1" max="50" step="1" [(ngModel)]="borderWidth" (change)="editBorderWidth()" required>
        </div>
        <div class="field" *ngIf="isLine">
            <label class="field__label">Grosor</label>
            <input class="field-input field-input--sm" type="number" min="1" max="50" step="1" [(ngModel)]="lineWidth" (change)="editLineWidth()" required>
        </div>
        <div class="field-range" *ngIf="isLine">
            <div class="field-range__head">
                <label class="field__label">Curvatura</label>
                <span class="field-range__value">
                    <input type="number" min="-200" max="200" step="2" [(ngModel)]="curvature" (input)="editCurvature()">
                </span>
            </div>
            <input type="range" min="-200" max="200" step="2" [(ngModel)]="curvature" (input)="editCurvature()" class="slider-rotation">
        </div>
    </div>

    <!-- Forma -->
    <div class="panel-group" *ngIf="(sectionElement?.type !== 'ellipse' && !isLine) || isPolygon">
        <p class="panel-group__title">Forma</p>
        <div class="field" *ngIf="sectionElement?.type !== 'ellipse' && !isLine">
            <label class="field__label">Editar forma</label>
            <mat-checkbox [(ngModel)]="editForm" class="checkbox" color="primary" (change)="editFormSection()"></mat-checkbox>
        </div>
        <div *ngIf="editForm">
            <p class="field-hint">
                Arrastra el <strong>+</strong> de una arista para añadir un vértice ahí.
                Usa <strong>−</strong> para quitar el último vértice.
            </p>
            <div class="vertices-controls">
                <button class="btn-vertex btn-vertex-remove" (click)="removeLastVertex()" title="Eliminar último vértice">
                    <i class="fa-light fa-minus"></i>
                </button>
                <span class="vertices-count">{{ sectionElement?.points?.length }} vértices</span>
                <button class="btn-vertex" (click)="addVertex()" title="Añadir vértice (última arista)">
                    <i class="fa-light fa-plus"></i>
                </button>
            </div>
        </div>
        <div class="field-range" *ngIf="isPolygon">
            <div class="field-range__head">
                <label class="field__label">Redondear aristas</label>
                <span class="field-range__value">
                    <input type="number" min="0" max="150" step="1" [(ngModel)]="cornerRadius" (input)="editCornerRadius()">
                </span>
            </div>
            <input type="range" min="0" max="150" step="1" [(ngModel)]="cornerRadius" (input)="editCornerRadius()" class="slider-rotation">
        </div>
        <div class="field" *ngIf="isPolygon">
            <label class="field__label">Curvar aristas</label>
            <mat-checkbox [(ngModel)]="curveEdgesMode" class="checkbox" color="primary" (change)="editCurveEdges()"></mat-checkbox>
        </div>
        <p class="field-hint" *ngIf="curveEdgesMode">
            Arrastra el punto <strong style="color:#2d8cff;">azul</strong> del centro de una arista
            hacia fuera o hacia dentro para abombarla. Vuelve al centro para dejarla recta.
        </p>
    </div>

    <!-- Transformación -->
    <div class="panel-group">
        <p class="panel-group__title">Transformación</p>
        <div class="field-range">
            <div class="field-range__head">
                <label class="field__label">Rotar</label>
                <span class="field-range__value">
                    <input type="number" min="-180" max="180" step="1" [(ngModel)]="valueAngle" (input)="editRotation(valueAngle)">
                    <span class="field-range__unit">°</span>
                </span>
            </div>
            <input type="range" min="-180" max="180" step="1" [(ngModel)]="valueAngle" (input)="editRotation(valueAngle)" class="slider-rotation">
        </div>
    </div>
</div>
